import {useMemo} from "react";
import {useTranslation} from "react-i18next";

export default function useIntegrationScript(scriptName, integrationId) {
    let {t} = useTranslation();

    return useMemo(
        () => {
            if (integrationId === null) {
                return t('integration.shoptet.create-integration-to-show-script');
            }

            return `<script>
(function(d,x,o){
    var h=d.head,m=d.createElement('meta'),s=d.createElement('script');
    m.name='datixo-integration-id';m.content=o;s.async=true;
    s.src='https://api.datixo.app/static/integrations/'+x+'.js';h.append(m,s);
})(document,'${scriptName}','${integrationId}');
</script>`;
        },
        [scriptName, integrationId]
    );
}